// All user related database operations can be defined here.
/* eslint-disable */
import axios from 'axios'
import { GET_COMPANY, GET_JOB,GET_FILTERED_COMPANY } from './CONSTANTS'

/**
 * Function to fetch the details of the company based on his name.
 * @param {string} name of the company.
 */
export const getCompany = async (name) => {
  try {
    const res = await axios.get(GET_COMPANY(name))
    return res.data
  } catch (e) {
    console.error('in companyService > getCompanyDetails, Err===', e)
    return e
  }
}

export const getFilteredCompany = async (params) => {
	
  try {
    const res = await axios.get(GET_FILTERED_COMPANY, { params })
    return res.data
  } catch (e) {
    console.error('in companyService > getFilteredCompany, Err===', e)
    return e
  }
}

/**
 * Function to fetch the details of the job based on id.
 * @param {string} id of the company.
 */
export const getJob = async (id) => {
  try {
    const res = await axios.get(GET_JOB(id))
    return res.data
  } catch (e) {
    console.error('Error in get job axios , Err===', e)
    return e
  }
}
